import type { ParsedUrlQuery } from 'querystring';
import CookieService from './miscUtils/CookieService';

function captureSFEmailParams(queryParams: ParsedUrlQuery) {
  const { e, j, jb, l, mid, sfmc_sub, u } = queryParams;
  const conversionParams = {
    batchId: jb,
    email: e || '',
    jobId: j,
    jobUrlId: u,
    listId: l,
    memberId: mid,
    subId: sfmc_sub,
  };

  const isValid = Object.values(conversionParams).every((param) => param !== undefined);

  if (isValid) {
    CookieService.set('sfconversionparams', JSON.stringify(conversionParams));
  }
}

export default captureSFEmailParams;
